import SubscriptionDeactivateModal from './SubscriptionDeactivateModal';

export default SubscriptionDeactivateModal;
